'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _immutable = require('immutable');

var Immutable = _interopRequireWildcard(_immutable);

var _paymentConstants = require('./paymentConstants');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// Initial state
var initialState = Immutable.fromJS({
    viewState: _paymentConstants.PAYMENT_VIEW_STATES.CARD_FORM,
    plans: undefined,
    coupon: undefined,
    upcomingInvoice: undefined,
    prorateDate: undefined
});

var fetching = Immutable.Map({ fetching: true });

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case _paymentConstants.PAYMENT_SET_VIEW_STATE:
            return state.set('viewState', action.viewState);
        case _paymentConstants.PAYMENT_PLANS_FETCHING:
            return state.set('plans', undefined);
        case _paymentConstants.PAYMENT_PLANS_FETCHED:
            return state.set('plans', Immutable.fromJS(action.plans));
        case _paymentConstants.PAYMENT_PLANS_FAILED:
            return state.set('plans', undefined);
        case _paymentConstants.PAYMENT_COUPON_FETCHING:
            return state.set('coupon', fetching);
        case _paymentConstants.PAYMENT_COUPON_FETCHED:
            return state.set('coupon', Immutable.fromJS(action.coupon));
        case _paymentConstants.PAYMENT_COUPON_FAILED:
            return state.set('coupon', Immutable.fromJS(action.coupon));
        case _paymentConstants.PAYMENT_COUPON_CLEAR:
            return state.set('coupon', Immutable.fromJS({ visible: true }));
        case _paymentConstants.PAYMENT_UPCOMING_FETCHING:
            return state.set('upcomingInvoice', fetching);
        case _paymentConstants.PAYMENT_UPCOMING_FETCHED:
            return state.set('upcomingInvoice', Immutable.fromJS(action.invoice));
        case _paymentConstants.PAYMENT_UPCOMING_FAILED:
            return state.set('upcomingInvoice', undefined);
        case _paymentConstants.PAYMENT_SET_PRORATE_DATE:
            return state.set('prorateDate', action.date);
        case 'redux-form/DESTROY':
            if (action.form === _paymentConstants.PAYMENT_FORM_NAME) return initialState;
            return state;
        default:
            return state;
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/client/user/account/payment/paymentModalReducer.js
// module id = 2063
// module chunks = 0